var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "top-deals-container" }, [
    _c("h2", { staticClass: "h2" }, [_vm._v(_vm._s(_vm.$t("top_deals")))]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "city-list" },
      _vm._l(_vm.cityList, function(item) {
        return _c("li", { key: item.city_code, staticClass: "list-item" }, [
          _c(
            "div",
            {
              staticClass: "list-item-inner",
              class: {
                "list-item-active": item.city_code === _vm.cityCode
              },
              on: {
                click: function($event) {
                  _vm.select(item)
                }
              }
            },
            [_vm._v(_vm._s(item.title))]
          )
        ])
      })
    ),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "hotel-list" },
      _vm._l(_vm.cityHotelList, function(hotel, index) {
        return _c(
          "top-deals-hotel",
          _vm._b(
            {
              key: index,
              attrs: { cityGis: _vm.cityGis },
              nativeOn: {
                click: function($event) {
                  _vm.linkTo(hotel)
                }
              }
            },
            "top-deals-hotel",
            hotel,
            false
          )
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db27cde2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db27cde2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/components/TopDeals.vue
// module id = null
// module chunks = 